import { stitch } from 'keo';
import { Card, CardText, CardTitle } from 'material-ui/Card';
import PropTypes from 'prop-types';
import r from 'render-dom';
import { Col, Container, Row } from 'react-grid-system';

import Navigation from 'components/public/Navigation';
import PasswordReset from 'components/shared/PasswordReset';
import StickyHeader from 'components/shared/StickyHeader';
import { parseQueryString } from 'utils/helpers';


const propTypes = {
    hasResetPassword: PropTypes.bool.isRequired,
    history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
    location: PropTypes.shape({ search: PropTypes.string.isRequired }).isRequired,
    resetPassword: PropTypes.func.isRequired,
};

const style = {
    cardText: { paddingTop: 0 },
    cardTitle: { paddingBottom: 0 },
    container: { paddingTop: 40 },
};

const render = ({ props }) => {
    const { hasResetPassword, history, location: { pathname, search } } = props;
    const resetCode = parseQueryString(search).code;

    return (
        r.div([
            r(Navigation, { pathname }),
            r(StickyHeader, { title: 'Set Password' }),
            r.div([
                r(Container, { style: style.container }, [
                    r(Row, [
                        r(Col, {
                            offset: { sm: 3 },
                            sm: 6,
                        }, [
                            r(Card, [
                                r(CardTitle, {
                                    isRendered: !hasResetPassword,
                                    style: style.cardTitle,
                                    subtitle: resetCode
                                        ? ''
                                        : `Don't worry. Enter your email address and we'll send
                                        you a link to reset your password.`,
                                    title: resetCode
                                        ? 'Set Your Password'
                                        : 'Forgot Your Password?',
                                }),
                                r(CardText, { style: style.cardText }, [
                                    r(PasswordReset, { history, resetCode }),
                                ]),
                            ]),
                        ]),
                    ]),
                ]),
            ]),
        ])
    );
};

export default stitch(
    { propTypes, render },
    ({ auth }) => ({ hasResetPassword: auth.get('hasResetPassword') })
);



// WEBPACK FOOTER //
// ./src/components/public/Reset/index.js